(function(config) {
    'use strict';

    angular.module('settings.services', [
            'ngResource'
        ])
        .factory('faqDataSrvc', faqDataSrvc)
        .factory('faqSrvc', faqSrvc)
        .factory('bannerDataSrvc', bannerDataSrvc)
        .factory('bannerSrvc', bannerSrvc)
        .factory('dataImportSrvc', dataImportSrvc)
        .factory('variableDataSrvc', variableDataSrvc)
        .factory('variableSrvc', variableSrvc)
        .factory('translationDataSrvc', translationDataSrvc)
        .factory('settingDataSrvc', settingDataSrvc)
        .factory('settingSrvc', settingSrvc)
        .factory('systemLogDataSrvc', systemLogDataSrvc)
        .factory('contactDataService', contactDataService)
        .factory('contactSrvc', contactSrvc);

    faqDataSrvc.$inject = ['$resource'];

    function faqDataSrvc($resource) {
        return $resource(config.api + '/api/v1/faqs/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    faqSrvc.$inject = ['faqDataSrvc', 'modalSrvc'];

    function faqSrvc(faqDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    faqDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    bannerDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function bannerDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/banners/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    bannerSrvc.$inject = ['bannerDataSrvc', 'modalSrvc'];

    function bannerSrvc(bannerDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    bannerDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    dataImportSrvc.$inject = ['$resource'];

    function dataImportSrvc($resource) {
        return $resource('', {}, {
            dataImport: {
                method: 'POST',
                url: config.api + '/api/v1/data-import/'
            },
            dataImportStatus: {
                method: 'GET',
                url: config.api + '/api/v1/data-import-status/'
            },
            dataImportStatusReset: {
                method: 'POST',
                url: config.api + '/api/v1/data-import-status-reset/'
            }
        });
    }

    variableDataSrvc.$inject = ['$resource'];

    function variableDataSrvc($resource) {
        return $resource(config.api + '/api/v1/variables/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    translationDataSrvc.$inject = ['$resource', 'transformResponseSrvc', 'transformRequestSrvc'];

    function translationDataSrvc($resource, transformResponseSrvc, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/translation/:id/', { id: '@id' }, {
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            update: {
                method: 'PATCH'
            },
            modelsList: {
                url: config.api + '/api/v1/translation-models/',
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            modelsUpdate: {
                url: config.api + '/api/v1/translation-models/',
                method: 'PATCH'
            },
            modelsExport: {
                url: config.api + '/api/v1/translation-models/export/',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.excelArrayBufferTransform
            },
            modelsImport: {
                url: config.api + '/api/v1/translation-models/import_from_file/',
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            }
        });
    }

    settingDataSrvc.$inject = ['$resource'];

    function settingDataSrvc($resource) {
        return $resource(config.api + '/api/v1/settings/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    variableSrvc.$inject = ['variableDataSrvc', 'modalSrvc'];

    function variableSrvc(variableDataSrvc, modalSrvc) {
        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    variableDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    settingSrvc.$inject = ['settingDataSrvc', 'modalSrvc'];

    function settingSrvc(settingDataSrvc, modalSrvc) {
        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    settingDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    systemLogDataSrvc.$inject = ['$resource'];

    function systemLogDataSrvc($resource) {
        return $resource(config.api + '/api/v1/system_logs/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            }
        });
    }

    contactDataService.$inject = ['$resource', 'transformRequestSrvc'];

    function contactDataService($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/contact/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/contact/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            contactForUserCompetences: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/contact/admin_contact_for_user_competences/'
            },
            getMessageDetails: {
                method: 'GET',
                url: config.api + '/api/v1/contact/:pk/',
                params: {
                    pk: '@pk'
                }
            },
            sendMessage: {
                method: 'POST',
                url: config.api + '/api/v1/messages/'
            },
            readMessage: {
                method: 'PATCH',
                url: config.api + '/api/v1/messages/:pk/read_message/',
                params: {
                    pk: '@pk'
                }
            },
            addMessageFile: {
                method: 'POST',
                url: config.api + '/api/v1/message-files/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            }
        });
    }

    contactSrvc.$inject = ['$q', 'contactDataService', 'modalSrvc'];

    function contactSrvc($q, contactDataService, modalSrvc) {
        return {
            remove: remove,
            addMessageFiles: addMessageFiles
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    contactDataService.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function addMessageFiles(messageId, files) {
            var promises = [];
            for (var i = 0; i < files.length; ++i) {
                promises.push(
                    contactDataService.addMessageFile({
                        message: messageId,
                        file: files[i]
                    }).$promise
                );
            }

            return $q.all(promises);
        }
    }
})(window.config);
